if (!customElements.get("cart-attributes")) {
  customElements.define(
    "cart-attributes",
    class CartAttributes extends HTMLElement {
      constructor() {
        super();
        this.fields = Array.from(this.querySelectorAll("[required]"));

        this.fields.forEach((field) =>
          field.addEventListener("input", this.handleInput.bind(this))
        );
        this.cartSubmitButton = document.getElementById("checkout");
        this.cartDrawerSubmitButton = document.getElementById(
          "CartDrawer-Checkout"
        );

        this.fields.forEach((field) => {
          if (field.validity.valid) {
            this.hideError(field);
          } else {
            this.showError(field);
          }
        });
        this.validator();
      }

      validator() {
        const isValid = (field) => field.validity.valid;
        if (this.fields.every(isValid)) {
          this.enableCheckout();
        } else {
          this.disableCheckout();
        }
      }

      handleInput(event) {
        //var formData = new FormData(document.querySelector(`#${this.dataset.formId}`));
        var formData = new FormData();
        formData.append(`[${event.target.name}]` , event.target.validity.valid ? event.target.value: '');
        fetch("/cart/update.js", {
          method: "POST",
          body: formData,
        }).then((response) => response.json())
          .then((data) => {
            if (event.target.validity.valid) {
              this.hideError(event.target);
            } else {
              this.showError(event.target);
            }
            this.validator();
          })
          .catch((error) => {
            console.error("Error adding cart attribute:", error);
          });
      }

      showError(element) {
        const formError = element
          .closest(".field-wrapper")
          ?.querySelector(".form-error");
        if (formError) formError.classList.remove("hidden");
      }

      hideError(element) {
        const formError = element
          .closest(".field-wrapper")
          ?.querySelector(".form-error");
        if (formError) formError.classList.add("hidden");
      }

      enableCheckout() {
        if (this.cartSubmitButton) this.cartSubmitButton.disabled = false;
        if (this.cartDrawerSubmitButton)
          this.cartDrawerSubmitButton.disabled = false;
      }
      disableCheckout() {
        if (this.cartSubmitButton) this.cartSubmitButton.disabled = true;
        if (this.cartDrawerSubmitButton)
          this.cartDrawerSubmitButton.disabled = true;
      }
    }
  );
}
